// extracted by mini-css-extract-plugin
export default {"container":"WritingsList_container__F3Bqr","cardsContainer":"WritingsList_cardsContainer__UfUW8"};